var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"t-heading-3"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),_c('p',{staticClass:"t-paragraph"},[_vm._v("\n    "+_vm._s(_vm.subtitle)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }